import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=09c06b12&scoped=true&"
import script from "./layout-footer.vue?vue&type=script&lang=ts&"
export * from "./layout-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c06b12",
  null
  
)

export default component.exports